import type { NonChargeAbilityBucketInput, NonChargeAbilityEntryInput } from '../types';
import { comparePhpStrings } from './php-json-values';

function phpNumericCompare(left: number, right: number): number {
    const a = Number.isFinite(left) ? left : 1;
    const b = Number.isFinite(right) ? right : 1;
    return a < b ? -1 : a > b ? 1 : 0;
}

function isUuid(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
}

/** Final dedupe and re-sort pass from finalize_creature_abilities(). */
export function finalizeNonChargeAbilityBucket(input: NonChargeAbilityBucketInput): NonChargeAbilityEntryInput[] {
    const seen = new Set<string>();
    const unique: NonChargeAbilityEntryInput[] = [];
    for (const entry of input.entries) {
        if (entry.abilityId === '') continue;
        const key = input.layer === 'attack_ability' && entry.drawsSheathedWeapon && isUuid(entry.source)
            ? `${entry.abilityId}|${entry.source}`
            : entry.abilityId;
        if (seen.has(key)) continue;
        seen.add(key);
        unique.push(entry);
    }
    if (input.layer === 'at_will_spell' || input.layer === 'curses_known') {
        unique.sort((left, right) => comparePhpStrings(left.name, right.name));
    } else {
        unique.sort((left, right) => phpNumericCompare(left.requiresLevel, right.requiresLevel));
    }
    return unique;
}
